import apiService from "./apiService";

const ORDER_BASE = "/backend"; // prefix from api.php (admin routes)

/**
 * ORDER SERVICE – For Admin Panel
 */
const orderService = {

  // ==========================
  // Fetch ALL Orders
  // ==========================
  getAllOrders: () => {
    return apiService.getAll(`${ORDER_BASE}/all-orders`);
  },

  // ==========================
  // Fetch NEW Pending Orders (Last 7 Days)
  // ==========================
  getNewPendingOrders: () => {
    return apiService.getAll(`${ORDER_BASE}/new-orders-pending`);
  },

  // ==========================
  // Fetch Pending Orders
  // ==========================
  getPendingOrders: () => {
    return apiService.getAll(`${ORDER_BASE}/orders-pending`);
  },

  // ==========================
  // Fetch Delivered Orders
  // ==========================
  getDeliveredOrders: () => {
    return apiService.getAll(`${ORDER_BASE}/orders-delivered`);
  },

  // ==========================
  // Fetch Cancelled Orders
  // ==========================
  getCancelledOrders: () => {
    return apiService.getAll(`${ORDER_BASE}/orders-cancelled`);
  },

  // ==========================
  // Fetch Details of a Single Order by ID
  // ==========================
  getOrderById: (id) => {
    return apiService.getById(`${ORDER_BASE}/orders`, id);
  },

  // ==========================
  // Update Order Status & Payment Status
  // ==========================
  updateStatus: (id, data) => {
    return apiService.post(`${ORDER_BASE}/orders/${id}/update-status`, data);
  },

};

export default orderService;

